import { useEffect, useState } from "react";

function currentMatch(query: string, fallback: boolean): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(query).matches
    : fallback;
}

export function useMediaQuery(query: string, fallback = false): boolean {
  const [matches, setMatches] = useState(() => currentMatch(query, fallback));

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      setMatches(fallback);
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const update = (event?: MediaQueryListEvent) => setMatches(event?.matches ?? mediaQuery.matches);
    update();
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", update);
      return () => mediaQuery.removeEventListener("change", update);
    }
    mediaQuery.addListener(update);
    return () => mediaQuery.removeListener(update);
  }, [fallback, query]);

  return matches;
}
